/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Blockstatuspending2Inputs */

const zh_learn_blockstatuspending2 = /** @type {(inputs: Learn_Blockstatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待开始`)
};

const en_learn_blockstatuspending2 = /** @type {(inputs: Learn_Blockstatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const es_learn_blockstatuspending2 = /** @type {(inputs: Learn_Blockstatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pendiente`)
};

/**
* | output |
* | --- |
* | "pending" |
*
* @param {Learn_Blockstatuspending2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockstatuspending2 = /** @type {((inputs?: Learn_Blockstatuspending2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockstatuspending2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockstatuspending2(inputs)
	if (locale === "en") return en_learn_blockstatuspending2(inputs)
	return es_learn_blockstatuspending2(inputs)
});
export { learn_blockstatuspending2 as "learn_blockStatusPending" }